import * as yup from 'yup';
import { providentBaseInputSchema } from '@/features/Sparten/shared/schema/provident/providentInputSchema';

export const rlvSchema = providentBaseInputSchema.concat(
  yup.object({
    versicherungssumme: yup
      .number()
      .min(10000)
      .max(10000000)
      .default(300000)
      .required(),
    leistungsverlauf: yup.string().required().default(''),
    motorradfahrer: yup.boolean().required().default(false),
  }),
);
